module.exports = __webpack_public_path__ + "img/chinesecompany54.9f69f042.png";